<template>
  <a class="Link"><slot></slot></a>
</template>

<script>
export default {
  name: "Link"
};
</script>

<style scoped lang="scss">
@import "../styles/_variables.scss";

.Link {
  color: $c-green;

  &:hover {
    color: $c-blue;
  }
}
</style>
